module.exports = __webpack_public_path__ + "static/media/view2.bdf56eb3.jpg";